module.exports = __webpack_public_path__ + "static/media/obama.6044a72b.jpg";